import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, ReplaySubject } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';
import { Domain } from '../models/domain';

@Injectable({
  providedIn: 'root'
})
export class DomainService {
  private readonly baseUrl;

  private domainState = new ReplaySubject<object | null>(1);
  private domainCache$?: Observable<object | null>;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  updateDomain(force?: boolean): void {
    if (!this.domainCache$ || force) {
      this.domainCache$ = this.http.get(this.baseUrl + 'domain').pipe(
        map(domain => Domain.deserialize(domain)),
        tap(domain => {
          let logoFieldsPopulated = true;
          Object.keys(domain).forEach(key => {
            if (key === 'logoUrl' && domain[key] === '') {
              logoFieldsPopulated = false;
              return;
            }
          });
          if (!logoFieldsPopulated) {
            domain.logoUrl = 'brands-styles/default/brand-logo.svg';
            domain.logoMobileUrl = 'brands-styles/default/brand-logo-s.svg';
          }
        }),
        // map(entries => _keyBy(entries)),
        shareReplay()
      );
    }
    this.domainCache$.subscribe(domain => this.domainState.next(domain));
  }

  getDomainState(): Observable<any | null> {
    if (!this.domainCache$) {
      this.updateDomain(true);
    }
    return this.domainState.asObservable();
  }

  getDomainInfo(): Observable<Domain> {
    return this.http.get<Domain>(this.baseUrl + 'domain');
  }
}
